<template>
    <div class="row mt-3">
        <div class="col-12">
            <h4 class="h4">{{ __("messages.see_other_destinations") }} {{destination}}</h4>

            <div class="row">
                <div v-for="item in similarDestination" class="col-6 col-md-4 col-lg-2">
                    <a class="link" :href="`${siteConfig.siteUrl}/${culture.cultureCode}/${__('url.url_destination')}/${item.uri}`" :title="item.name">
                        {{item.name}}
                    </a>
                    <p class="link-description">{{item.hotelCount}} {{ __("messages.hotels") }}</p>
                </div>
            </div>

        </div>
    </div>
</template>


<script>

    const site = window.__pt.settings.site;
    const culture = window.__pt.cultureData
;

    export default {
        props: {
            similarDestination: Array,
            destination: String
        },
        data() {
            return {
                siteConfig: site,
                culture: culture,

            };
        },
    };
</script>